import { skipToken, useQuery } from "@tanstack/react-query";
import {
  getPartiesPartyIdentificationImagesPublicID,
  type GetPartyIdentificationImagesQueryResult,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const PARTY_IDENTIFICATION_IMAGES_QUERY_KEY = "PARTY_IDENTIFICATION_IMAGES";

export const partyIdentificationImagesKeys = {
  all: [PARTY_IDENTIFICATION_IMAGES_QUERY_KEY],
  byPublicId: (publicID?: string) => [
    ...partyIdentificationImagesKeys.all,
    publicID,
  ],
};

type Props = {
  publicID?: string;
  enabled?: boolean;
};

export const usePartyIdentificationImagesQuery = ({
  publicID,
  enabled = true,
}: Props) =>
  useQuery<GetPartyIdentificationImagesQueryResult>({
    queryKey: partyIdentificationImagesKeys.byPublicId(publicID),
    queryFn: publicID
      ? processResponseWithApiProblemDetails(() =>
          getPartiesPartyIdentificationImagesPublicID(publicID),
        )
      : skipToken,
    enabled: enabled && !!publicID,
    staleTime: 60 * 1000, // 1 minute - reduced for large base64 payloads, can be increased when using azure storage urls for images
    gcTime: 2 * 60 * 1000, // 2 minutes - clear cache shortly after component unmount
    refetchOnWindowFocus: false, // Sensitive data
  });
